import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { getUniqueId } from "utils";
import sponsorsList from "./sponsorsList";
import translate from "../../../../i18n/translate";
import { SrDialog } from "../../../common";

const SponsorsDialog = ({ handleClose, open }) => (
  <SrDialog
    open={open}
    heading={translate("speiTransfer.banksLogos")}
    handleClose={handleClose}
    size="md"
  >
    <Grid container spacing={1} justifyContent="center">
      {sponsorsList.map((bank) => (
        <Grid item xs={12} sm={6} md={3} key={getUniqueId("bank")}>
          {bank}
        </Grid>
      ))}
    </Grid>
  </SrDialog>
);

SponsorsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default SponsorsDialog;
